import type {IssueType} from "../../domain/entities/issue-type.entity";

/** The issue type fields the legacy grid draws on its cells (`abstract-ha-timeline.view.ts`). */
export const ISSUE_TYPE_RENDER_FIELDS: ReadonlyArray<keyof IssueType> = [`color`, `textColor`, `shortcut`];

/**
 * Whether a change of an issue type must redraw the legacy grid's cells: its colour, its text colour (feature plan
 * 0074 — without it a change of only the text colour stayed invisible until a reload) or its shortcut.
 */
export function isIssueTypeRenderChange(changeSet: object): boolean {
    return Object.keys(changeSet).some(key => (ISSUE_TYPE_RENDER_FIELDS as ReadonlyArray<string>).includes(key));
}
